<template>
    <div class="thankyou-container">
      <main class="thankyou-card">
        
        <div class="success-icon-wrapper">
          <div class="success-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
          </div>
        </div>
  
        <h1 class="headline">Checklist Request Sent</h1>
        
        <p class="subheadline">
          The tenant risk checklist has been sent to your email.
        </p>
  
        <div class="delivery-expectation-box">
          <!-- <span class="sender-label">Sender Identity:</span> -->
          <span class="sender-tag">Shelta costomer experience</span>
          <p class="expectation-text">
            Please scan spam or promo folders if checklist latency occurs.
          </p>
        </div>
  
        <div class="divider">
          <span>OR</span>
        </div>
  
        <section class="instant-action-block">
          <h3>Accelerated Landlord Escalation</h3>
          <p>
            Managing an active dispute, non-paying occupant, or critical tenancy legal emergency right now? Fast-track the delay.
          </p>
  
          <a 
            :href="whatsappUrl" 
            target="_blank" 
            rel="noopener noreferrer" 
            class="whatsapp-button"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
            </svg>
            <span>Initiate Direct WhatsApp Chat</span>
          </a>
  
          <!-- <p class="trust-marker">⚡ Connected to a certified Shelta Portfolio Specialist. Zero automated bots.</p> -->
        </section>
  
        <footer class="thankyou-footer">
          <button @click="$emit('back')" class="back-link">
            Return to previous page
          </button>
        </footer>
  
      </main>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ThankYouPage',
    props: {
      userData: {
        type: Object,
        default: () => ({ email: '', state: '' })
      }
    },
    data() {
      return {
        // +2348061796909
        whatsappUrl: 'https://api.whatsapp.com/send?phone=2348061796909'
      };
    }
  };
  </script>
  
  <style lang="scss" scoped>
  $primary: #0f172a;
  $whatsapp-green: #16a34a;
  $text-dark: #1e293b;
  $text-muted: #64748b;
  $border: #e2e8f0;
  
  .thankyou-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
    background-color: #f1f5f9;
    margin-top: 8.5rem;
  }
  
  .thankyou-card {
    background: #ffffff;
    border: 1px solid $border;
    border-radius: 12px;
    padding: 2.5rem 1.5rem;
    max-width: 540px;
    width: 100%;
    text-align: center;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
  }
  
  .success-icon-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 1.5rem;
  
    .success-icon {
      background-color: #ecfdf5;
      color: #059669;
      padding: 1rem;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  
  .headline {
    color: $primary;
    font-size: 1.75rem;
    font-weight: 800;
    margin-bottom: 1rem;
    letter-spacing: -0.02em;
  }
  
  .subheadline {
    color: $text-muted;
    font-size: 1rem;
    line-height: 1.5;
    margin-bottom: 2rem;
  }
  
  .delivery-expectation-box {
    background-color: #f8fafc;
    border: 1px dashed $border;
    border-radius: 6px;
    padding: 1.25rem;
    text-align: left;
    margin-bottom: 2rem;
  
    .sender-label {
      font-size: 0.8rem;
      font-weight: 600;
      color: $text-muted;
    }
  
    .sender-tag {
      font-size: 0.8rem;
      font-weight: 700;
      color: $primary;
      background: #e2e8f0;
      padding: 0.15rem 0.4rem;
      border-radius: 4px;
      margin-left: 0.35rem;
    }
  
    .expectation-text {
      margin-top: 0.5rem;
      font-size: 0.85rem;
      color: $text-dark;
      line-height: 1.4;
    }
  }
  
  .divider {
    display: flex;
    align-items: center;
    text-align: center;
    margin-bottom: 2rem;
    color: $border;
  
    &::before, &::after {
      content: '';
      flex: 1;
      border-bottom: 1px solid $border;
    }
  
    span {
      padding: 0 1rem;
      font-size: 0.75rem;
      font-weight: 700;
      color: $text-muted;
      letter-spacing: 0.05em;
    }
  }
  
  .instant-action-block {
    background: #ffffff;
    border: 1px solid $border;
    border-radius: 8px;
    padding: 1.5rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
  
    h3 {
      font-size: 1.1rem;
      color: $primary;
      font-weight: 700;
      margin-bottom: 0.5rem;
    }
  
    p {
      font-size: 0.85rem;
      color: $text-muted;
      line-height: 1.4;
      margin-bottom: 1.25rem;
    }
  }
  
  .whatsapp-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    background-color: $whatsapp-green;
    color: #ffffff;
    text-decoration: none;
    padding: 0.85rem;
    border-radius: 6px;
    font-weight: 700;
    font-size: 0.95rem;
    transition: background-color 0.2s ease;
  
    &:hover {
      background-color: darken($whatsapp-green, 5%);
    }
  }
  
  .trust-marker {
    margin-top: 0.75rem;
    font-size: 0.75rem !important;
    color: $text-muted !important;
  }
  
  .thankyou-footer {
    margin-top: 2rem;
  
    .back-link {
      background: none;
      border: none;
      color: $text-muted;
      font-size: 0.85rem;
      text-decoration: underline;
      cursor: pointer;
  
      &:hover {
        color: $primary;
      }
    }
  }
  
  @media (min-width: 480px) {
    .thankyou-card {
      padding: 3rem;
    }
  }
  </style>
  